import { defineComponent as l, computed as r, createBlock as m, openBlock as s, unref as i, normalizeClass as u } from "vue";
import { RevAvatar as c } from "@ds/components/Avatar";
import p from "../../../icons/generated/IconBackMarketAvatar.vue2.js";
import f from "../../../icons/generated/IconShop.vue2.js";
const k = /* @__PURE__ */ l({
  __name: "MessageAvatar",
  props: {
    variant: {},
    label: {}
  },
  setup(a) {
    const e = a, t = r(() => e.variant === "customer" ? "mood-purple" : e.variant === "seller" ? "mood-emerald" : "mood-blush"), n = r(() => {
      if (e.variant === "backmarket") return p;
      if (e.variant === "seller") return f;
    });
    return (o, v) => (s(), m(i(c), {
      class: u(t.value),
      label: o.label,
      size: "medium",
      thumbnail: n.value
    }, null, 8, ["class", "label", "thumbnail"]));
  }
});
export {
  k as default
};
